import React from 'react';

// styles
import { RelatedLinksStyled } from './styles';

export default () => {
  const linkItems = [
    {
      linkUrl: '/assets/pdf/brochures/power-of-the-portfolio.pdf',
      linkId: 'related-links-power-of-the-portfolio',
      linkText: 'The Power of the Portfolio',
      ariaLabel: '',
      isOutgoingLink: true,
      children: '',
    },
    {
      linkUrl: '/assets/pdf/financial-reports/investment-report.pdf',
      linkId: 'related-links-annual-investment-report',
      linkText: 'Annual Investment Report',
      ariaLabel: '',
      isOutgoingLink: true,
      children: '',
    },
  ];

  return (
    <RelatedLinksStyled
      sectionId='related-links-1-financial-information-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding />
  );
};
